import { base, baseODATA } from '../base';

export const creative = `${base}/adcreative`;
export const getCreativeQueryOdata = `${baseODATA}/adcreativesearchquery`;
export const creativeBrandVoice = `${base}/AdCreativeBrandVoice`;
export const creativeFunnelStage = `${base}/AdCreativeFunnelStage`;
export const creativeSegment = `${base}/AdCreativeSegment`;
